import { cx } from 'class-variance-authority';
import { ChevronDown } from 'lucide-react';

export const AccordionItem = ({ title, content, isOpen, onClick, contentClassName }) => {
    return (
        <div className="border-2 mb-2 border-slate-200">
            <button
                className="w-full flex justify-between items-center p-1 text-left font-medium transition-colors duration-200"
                onClick={onClick}
                aria-expanded={isOpen}
            >
                <span className="font-bold">{title}</span>
                <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                    {/* ▼ */}
                    <ChevronDown />
                </span>
            </button>

            {/* Animated Content Wrapper */}
            <div
                className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
            >
                <div className="overflow-hidden">
                    <div className={cx("p-2 border-t-2 text-sm text-slate-600 leading-relaxed", contentClassName)}>
                        {content}
                    </div>
                </div>
            </div>
        </div>
    );
};
